import {
  CUSTOM_OUTAGE_MESSAGE,
  PCC_EMERGENCY_MESSAGE
} from '@app/components/global-banners/constants';
import { useECT } from '@app/hooks';
import { useSelector } from 'react-redux';
import { EMERGENGY_MESSAGE_FLAG } from '@app/constants/featureFlags';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';

const ShoppingCartOutageWarning = () => {
  const FEATURE_FLAG = EMERGENGY_MESSAGE_FLAG;
  const flagEnabled = useSelector(s => s.featureFlag?.[FEATURE_FLAG]);
  const { data: emergencyMessage } = useECT(
    PCC_EMERGENCY_MESSAGE,
    CUSTOM_OUTAGE_MESSAGE,
    flagEnabled
  );
  const customOutageMessageECT = emergencyMessage?.text;
  let customOutageMessageDealer = useSelector(
    s => s.dealer.customOutageMessage
  );
  let customOutageMessage = null;
  const customOutageMessageEnabled = useSelector(
    s => s.dealer.customOutageMessageEnabled
  );
  if (flagEnabled) {
    customOutageMessage = customOutageMessageECT;
  } else if (customOutageMessageEnabled) {
    customOutageMessage = customOutageMessageDealer;
  }

  if (
    typeof customOutageMessage !== 'object' &&
    !Array.isArray(customOutageMessage) &&
    customOutageMessage !== null
  ) {
    customOutageMessage = { contents: [{ html: customOutageMessage }] };
  }

  const customOutageEspotMessage =
    customOutageMessage?.contents?.length > 0 &&
    customOutageMessage?.contents[0]?.html;

  const checkMessage = customOutageMessage?.contents[0]?.html;

  return checkMessage ? (
    <div className="cat-u-margin-bottom-md">
      <CatInlineNotification
        heading={customOutageEspotMessage}
        variant="warning"
        dismissible={true}
        data-testid="custom-outage-message"
      >
        <CatIconWarningTriangle slot="before" />
      </CatInlineNotification>
    </div>
  ) : null;
};

export default ShoppingCartOutageWarning;
